//@flow

import LanguageModal from "./LanguageModal"

export default LanguageModal



// WEBPACK FOOTER //
// ./src/Kiosk/LanguageModal/index.js